import React, { useState, useEffect } from "react";
import { fetchData } from "../../Components/common/utils";
import MainLoader from "../../Components/MainLoader";
import { Link, NavLink, useLocation, useParams } from "react-router-dom";

function ShopLists() {
    const { id } = useParams();
    const [shopList, setShopList] = useState([]);
    const [loading, setLoading] = useState(true);
    const location = useLocation();

    // ✅ Unique filter lists
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [categories, setCategories] = useState([]);
    const [categoryTypes, setCategoryTypes] = useState([]);

    // ✅ Selected filters
    const [filters, setFilters] = useState({
        country: [],
        state: [],
        city: [],
        category: [],
        categoryType: [],
    });

    const [search, setSearch] = useState(""); // 🔥 search input
    const [filteredData, setFilteredData] = useState([]);

    // ✅ Fetch shops
    useEffect(() => {
        const fetchApiData = async () => {
            setLoading(true);
            const url = "api/shop/service/find-service-providers";
            const result = await fetchData(url);
            setLoading(false);

            if (result && result.data) {
                setShopList(result.data);

                // 🔥 Extract unique filter values
                setCountries([
                    ...new Map(result.data.map((item) => [item.country?.id, item.country])).values(),
                ]);
                setStates([
                    ...new Map(result.data.map((item) => [item.state?.id, item.state])).values(),
                ]);
                setCities([
                    ...new Map(result.data.map((item) => [item.city?.id, item.city])).values(),
                ]);
                setCategories([
                    ...new Map(result.data.map((item) => [item.category?.id, item.category])).values(),
                ]);
                setCategoryTypes([...new Set(result.data.map((item) => item.category_of_shop))]);
            }
        };
        fetchApiData();
    }, [id, location.key]);

    // ✅ Handle checkbox toggle
    const handleCheckboxChange = (filterKey, value) => {
        setFilters((prev) => {
            const newValues = prev[filterKey].includes(value)
                ? prev[filterKey].filter((v) => v !== value)
                : [...prev[filterKey], value];
            return { ...prev, [filterKey]: newValues };
        });
    };

    // ✅ Apply filters + search
    useEffect(() => {
        let data = [...shopList];

        // checkbox filters
        if (filters.country.length > 0) {
            data = data.filter((item) => filters.country.includes(item.country?.id));
        }
        if (filters.state.length > 0) {
            data = data.filter((item) => filters.state.includes(item.state?.id));
        }
        if (filters.city.length > 0) {
            data = data.filter((item) => filters.city.includes(item.city?.id));
        }
        if (filters.category.length > 0) {
            data = data.filter((item) => filters.category.includes(item.category?.id));
        }
        if (filters.categoryType.length > 0) {
            data = data.filter((item) => filters.categoryType.includes(item.category_of_shop));
        }

        // 🔎 search filter
        if (search.trim() !== "") {
            const searchLower = search.toLowerCase();
            data = data.filter((item) =>
                [
                    item.shop_name,
                    item.description,
                    item.phone,
                    item.country?.name,
                    item.state?.name,
                    item.city?.name,
                    item.category?.title,
                    item.category_of_shop,
                ]
                    .filter(Boolean)
                    .some((field) => field.toLowerCase().includes(searchLower))
            );
        }

        setFilteredData(data);
    }, [filters, shopList, search]);
    const shoptypeList = [
        { "value": "supplier", "label": "Supplier" },
        { "value": "technicians", "label": "Technicians" },
        { "value": "installer", "label": "Installer" },
        { "value": "retailer", "label": "Retailer" },
        { "value": "importer-exporter", "label": "Importer/Exporter" },
        { "value": "franchise-dealership", "label": "Franchise/Dealership" },
        { "value": "electrician", "label": "Electrician" },
        { "value": "mechanic", "label": "Mechanic" },
        { "value": "manufacturer", "label": "Manufacturer" }
    ]

    const ShopTypeName = (type) => {
        const typeObj = shoptypeList.find(t => t.value === type);
        return typeObj ? typeObj.label : type;
    }
    return (
        <div className="container">
            {loading && <MainLoader />}
            <div className="mt-4">
                <div className="brand-banner py-3 px-3 text-center text-white mb-4">
                    <h1 className="display-4 fw-bold mb-2">
                        Browse <span className="brand-name">Shops</span>
                    </h1>
                    <p className="lead">
                        Discover top-rated businesses, explore services, and find the right shop for
                        your needs
                    </p>
                    <NavLink to="/add-shop">
                        <button type="button" className="btn btn-primary">
                            Add Shop
                        </button>
                    </NavLink>
                </div>
            </div>

            <div className="row my-4">
                {/* Sidebar Filters */}
                <div className="col-md-3 mb-3">
                    <div className="p-3 border rounded " id="filters_col">
                        <a
                            className="d-flex h5  justify-content-between align-items-center"
                            data-bs-toggle="collapse"
                            href="#collapseFilters"
                            aria-expanded={window.innerWidth < 768 ? 'false' : 'true'}
                            aria-controls="collapseFilters"
                            id="filters_col_bt"
                        >
                            Filters
                            <i class="bi bi-funnel-fill"></i>
                        </a>
                        <div class={`collapse mt-3 ${window.innerWidth < 768 ? '' : 'show'} `} id="collapseFilters">
                            {/* Country */}
                            <div className="mb-3">
                                <h6 className="fw-bold">Country</h6>
                                {countries.map((c) => (
                                    <div key={c?.id} className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`country-${c.id}`}
                                            checked={filters.country.includes(c?.id)}
                                            onChange={() => handleCheckboxChange("country", c?.id)}
                                        />
                                        <label className="form-check-label" htmlFor={`country-${c?.id}`}>
                                            {c.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <hr />
                            {/* State */}
                            <div className="mb-3">
                                <h6 className="fw-bold">State</h6>
                                {states.map((s) => (
                                    <div key={s.id} className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`state-${s.id}`}
                                            checked={filters.state.includes(s.id)}
                                            onChange={() => handleCheckboxChange("state", s.id)}
                                        />
                                        <label className="form-check-label" htmlFor={`state-${s.id}`}>
                                            {s.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <hr />
                            {/* City */}
                            <div className="mb-3">
                                <h6 className="fw-bold">City</h6>
                                {cities.map((city) => (
                                    <div key={city.id} className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`city-${city.id}`}
                                            checked={filters.city.includes(city.id)}
                                            onChange={() => handleCheckboxChange("city", city.id)}
                                        />
                                        <label className="form-check-label" htmlFor={`city-${city.id}`}>
                                            {city.name}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <hr />
                            {/* Category */}
                            <div className="mb-3">
                                <h6 className="fw-bold">Category</h6>
                                {categories.map((cat) => (
                                    <div key={cat.id} className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`cat-${cat.id}`}
                                            checked={filters.category.includes(cat.id)}
                                            onChange={() => handleCheckboxChange("category", cat.id)}
                                        />
                                        <label className="form-check-label" htmlFor={`cat-${cat.id}`}>
                                            {cat.title}
                                        </label>
                                    </div>
                                ))}
                            </div>
                            <hr />
                            {/* Category of Shop */}
                            <div className="mb-3">
                                <h6 className="fw-bold">Business Type</h6>
                                {categoryTypes.map((type, i) => (
                                    <div key={i} className="form-check">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`type-${i}`}
                                            checked={filters.categoryType.includes(type)}
                                            onChange={() => handleCheckboxChange("categoryType", type)}
                                        />
                                        <label className="form-check-label" htmlFor={`type-${i}`}>
                                            {ShopTypeName(type)}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Shop List */}
                <div className="col-md-9">
                    {/* 🔎 Search Input */}
                    <div className="mb-3">
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Search by name, city, category, etc..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>

                    <div className="row">
                        {filteredData.map((item, index) => (
                            <div key={index} className="col-md-6 col-lg-4 mb-3">
                                <NavLink to={`${item.slug}`} >
                                    <div className="card h-100 shadow-sm">
                                        <img
                                            src={item.media[0]?.original_url}
                                            style={{ height: "15em", objectFit: "cover" }}
                                            className="w-100 card-img-top"
                                            alt={item.shop_name}
                                        />
                                        {item.is_verified !== 0 && (
                                            <span className="position-absolute bg-success text-white fw-bold px-3 py-2 small">
                                                Verified
                                            </span>
                                        )}
                                        <div className="card-body">
                                            <h5 className="card-title">{item.shop_name}</h5>
                                            <p className="card-text line-clamp-3">{item.description}</p>
                                            <p className="card-text mb-0 small"><strong>Contact No:</strong> {item.phone}</p>
                                            <p className="card-text mb-0 small"><strong>Address:</strong> {item.address}</p>
                                            <p className="card-text small"><strong>City:</strong> {item?.city?.name}</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </div>
                        ))}

                        {filteredData.length === 0 && (
                            <div className="text-center py-5">
                                <p>No shops found.</p>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ShopLists;
